import React from 'react';

const MenuOverlayItems = ({ children }) => (
  <div className="container container--overlays" role="dialog">
    <div className="menu-overlay">
      <div className="menu-overlay__wrapper">
        <div className="menu-overlay__grid">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default MenuOverlayItems;
